export interface ProductionFilterType {
  selectedProductions: server.dto.TourSmall[]
}

export const getProductionLabels = (filter: ProductionFilterType) => {
  return filter.selectedProductions.map(a => a.name)
    .sort((a, b) => a.localeCompare(b));
};

export const initialProductionFilter: ProductionFilterType = {
  selectedProductions: []
};